import Vue from 'vue'
import TestTakerResource from '../../api/TestTaker';
const initialState={
    testPreview       : null,
    totalPointsEarned : 0,
    // currently displayed question
    activeQuestion    : {},
    // array of questions marked with flag
    flaggedQuestions  : [],
    // track selected answers that have not been saved
    unsavedChanges    : {},
    // empty answer object
    blankAnswerObj    : {
        TEST_RID                  : "",
        TEST_QUESTION_RID         : "",
        ANSWER_RID                : "",
        CREATED_BY                : "",
        CREATED_DATE              : "",
        MODIFIED_BY               : "",
        MODIFIED_DATE             : "",
        POINTS_EARNED             : "",
        ANSWER_CORRECT_FLG        : "",
        QUESTION_GRADED_STATUS    : "",
        TEST_QUESTION_ANSWER_TEXT : "",
        QUESTION_GRADED_COMMENT   : "",
        QUESTION_ANSWERED_BY      : "",
        QUESTION_FLAGGED_FLG      : "0",
        QUESTION_GRADED_BY        : "",
        QUESTION_GENERAL_FEEDBACK : "",
        ANSWER_SPECIFIC_FEEDBACK  : ""
    },
    // track the student attempt start and finish
    testAttemptStartTime : "",
    testAttemptEndTime   : "",
    timeLimitExceeded    : false,
    testMode             : "",
    // utility flag is true if we're read-only
    reviewMode           : false,
    
    //primary keys of test instance
    testSession    : {}
};

const getters = {
    primaryQuestions: state => {
        return !!state.testPreview ? state.testPreview.QUESTIONS.filter( q =>{
            return !q.TEST_QUESTION_PARENT_RID; 
        } ) : [];
    }
};

const actions = {
    setActiveQuestionAction({ commit }, payload ){
        commit( "setActiveQuestion", payload);
    },

    load: ( { commit }, payload ) => {
        return new Promise( ( resolve, reject ) => {

            let TestTaker = new TestTakerResource({
                routeParams: payload.routeParams,
                query: payload.queryParams
            });
           
            if(payload.key === 'testPreview'){
                commit( "updateState", {
                    key   : 'testSession',
                    value : payload.queryParams
                } );
            }
            
            let promise = TestTaker.get()

            promise.then((result)=>{
                commit( "updateState", {
                    key   : payload.key,
                    value : result.data
                } );
                
                resolve( result.data );
            });
        } );
    },

    update: ( { commit }, payload ) => {
        return new Promise( ( resolve, reject ) => {
            let TestTaker = new TestTakerResource({
                routeParams: payload.routeParams,
                query: payload.queryParams
            });
    
            let promise = TestTaker.get()
            
            promise.then((result)=>{
                commit( "updateState", {
                    key   : payload.key,
                    value : result
                } );
                resolve( result.data );
            });
        } );
    },

    postAnswer: ( { commit, state }, payload ) => {
        return new Promise( ( resolve, reject ) => {
       
            // add question id and type to all requests
            payload.queryParams.question_type = state.activeQuestion.QUESTION_TYPE;
            payload.queryParams.test_rid = state.activeQuestion.TEST_RID;
            payload.queryParams.question_rid = state.activeQuestion.TEST_QUESTION_RID;
            payload.queryParams.school_id = state.testSession.school_id;
            payload.queryParams.course_id = state.testSession.course_id;
            payload.queryParams.section_id = state.testSession.section_id;
            payload.queryParams.teacher_rid = state.testSession.teacher_rid;
            payload.queryParams.student_rid = state.testSession.student_rid;

            let checkData = JSON.parse(payload.data);
            if(!!checkData.answer && !!checkData.questionType){
                if(checkData.questionType === "C"){
                    checkData.answer = checkData.answer.filter(ans=>{
                        return !!ans.ANSWER_RID && ans.ANSWER_RID.toString().length;
                    })
                    payload.data = JSON.stringify(checkData);
                }
            }
            let TestTaker = new TestTakerResource({
                routeParams: payload.routeParams,
                query: payload.queryParams,
                data: payload.data
            });
    
            let promise = TestTaker.post()
            
            promise.then((result)=>{
                commit( "setAnswer", result.data );
                // if immediate feedback is on, update with graded answers
                if( result.data.graded ){
                    commit( "setGradedAnswer", result.data.graded.answerKey );
                    if(!!result.data.test_total){ commit( "setTotalPoints", result.data.test_total );}
                    commit( "updateStudentAnswers", result.data.graded.gradedStudentResponse );
                }
                if(!!result.data.timesUp){
                    commit( "updateState", { key: "timeLimitExceeded", value: true } );
                }

                resolve( result.data );
            });
        } );
    },

    scoreAnswer: ( { commit, state }, payload ) => {
        return new Promise( ( resolve, reject ) => {
       
            // add question id and type to all requests
            payload.queryParams.question_type = state.activeQuestion.QUESTION_TYPE;
            payload.queryParams.test_rid = state.activeQuestion.TEST_RID;
            payload.queryParams.question_rid = state.activeQuestion.TEST_QUESTION_RID;
            payload.queryParams.school_id = state.testSession.school_id;
            payload.queryParams.course_id = state.testSession.course_id;
            payload.queryParams.section_id = state.testSession.section_id;
            payload.queryParams.teacher_rid = state.testSession.teacher_rid;
            payload.queryParams.student_rid = state.testSession.student_rid;
            let checkData = JSON.parse(payload.data);
            if(!!checkData.answer && !!checkData.questionType){
                if(checkData.questionType === "C"){
                    checkData.answer = checkData.answer.filter(ans=>{
                        return !!ans.ANSWER_RID && ans.ANSWER_RID.toString().length;
                    })
                    payload.data = JSON.stringify(checkData);
                }
            }
            let TestTaker = new TestTakerResource({
                routeParams: payload.routeParams,
                query: payload.queryParams,
                data: payload.data
            });
    
            let promise = TestTaker.post()
            
            promise.then((result)=>{
                commit( "setAnswer", result.data );
                if( result.data.graded ){
                    commit( "setGradedAnswer", result.data.graded.answerKey );
                    if(!!result.data.test_total){ commit( "setTotalPoints", result.data.test_total );}
                    commit( "updateStudentAnswers", result.data.graded.gradedStudentResponse );
                }

                resolve( result.data );
            });
        } );
    },

    submitTest: ( { dispatch, commit, state } ) => {
        
        return new Promise( ( resolve, reject ) => {
            if(confirm('Are you sure you wish to submit this test?')){
				let unsavedAnswerPromises = [];
                for( let key in state.unsavedChanges ) {
                    let answer = state.unsavedChanges[key];
                    answer.QUESTION_TYPE = answer.questionType;
                    answer.TEST_RID = answer.testId;
                    answer.TEST_QUESTION_RID = answer.questionId;
                    commit( "updateState", { key: "activeQuestion", value: answer } );
                    let payload = {};
                    payload.queryParams = {
                        question_type: answer.questionType,
                        test_rid: answer.testId,
                        question_rid: answer.questionId,
                        school_id: state.testSession.school_id,
                        course_id: state.testSession.course_id,
                        section_id: state.testSession.section_id,
                        teacher_rid: state.testSession.teacher_rid,
                        student_rid: state.testSession.student_rid
                    }; 
                    unsavedAnswerPromises.push(
                        dispatch( "scoreAnswer", {
                            "key": answer.questionId,
                            "data": JSON.stringify(answer),
                            "queryParams":payload.queryParams,
                            "routeParams":{ 
                                action: "score-question", 
                                testRid: answer.testId
                            } 
                        })
                    );
                }
				Promise.all( unsavedAnswerPromises ).then(() => {
                    let payload = {
                        queryParams:{},
                        routeParams:{}
                    };
                    payload.routeParams.action = "submit-test";
                    payload.routeParams.testRid = state.testPreview.TEST.TEST_RID;
                    payload.queryParams.test_rid = state.testPreview.TEST.TEST_RID;
                    payload.queryParams.school_id = state.testSession.school_id;
                    payload.queryParams.course_id = state.testSession.course_id;
                    payload.queryParams.section_id = state.testSession.section_id;
                    payload.queryParams.teacher_rid = state.testSession.teacher_rid;
                    payload.queryParams.student_rid = state.testSession.student_rid;

                    let TestTaker = new TestTakerResource({
                        routeParams: payload.routeParams,
                        query: payload.queryParams
                    });
            
                    let promise = TestTaker.post()
                    
                    promise.then((result)=>{
                        commit( "updateState", { key: "testAttemptEndTime", value: result.data.test_end_date } );
                        resolve( result.data );
                    });
                });
            }
            else{
                resolve({});
            }
            
        } );
    },
    
    // increments the active question
    nextQuestion ( { commit, state, getters } ){
        //  get working array of just question ids and omitting subquestions
        let results = getters.primaryQuestions.map( q =>{
            return q.TEST_QUESTION_RID; 
        } );

        // locate index of current question
        let currentIndex = results.indexOf( state.activeQuestion.TEST_QUESTION_RID );
        // increment index
        if( currentIndex + 1 < results.length ){
            currentIndex ++;
            // set the new active question ( omit sub questions )
            commit( "updateState", { key: "activeQuestion", value: getters.primaryQuestions[ currentIndex ] } );
        }else{
            // we've reached the end of the test. Display confirm and submit panel
            commit( "updateState", { key: "activeQuestion", value: null } );
        }
    },

    previousQuestion ( { commit, state, getters } ){
        //  get working array of just question ids and omitting subquestions
        let results = getters.primaryQuestions.map( q =>{
            return q.TEST_QUESTION_RID; 
        } );

        // locate index of current question or if coming from the confirm panel, the last question
        let currentIndex = state.activeQuestion ? results.indexOf( state.activeQuestion.TEST_QUESTION_RID ) : results.length;
        // increment index
        if( currentIndex > 0 ){
            currentIndex --;
        }else{
            currentIndex = 0;
        }
        // set the new active question ( omit sub questions )
        commit( "updateState", { key: "activeQuestion", value: getters.primaryQuestions[ currentIndex ] } );
    }

};

const mutations = {
    updateState ( state, payload ){
        Vue.set( state, payload.key, payload.value );
    },

    updateTestPreview ( state, payload ){
        Vue.set( state.testPreview, payload.key, payload.value );
    },

    setUnsaved ( state, payload ){
        if( !payload.value ){
            Vue.delete( state.unsavedChanges, payload.key );
        }else{
          Vue.set( state.unsavedChanges, payload.key, payload.value ); 
        }
    },

    clearUnsaved ( state ){
        state.unsavedChanges = [];
    },

    // adds the student answer response to the answer array, but it is not graded at this point
    setAnswer ( state, payload ){
        // if question has not been answered or is being updated, add answer
        if( payload && payload.questionType === "S" || payload.questionType === "N" ){
            if( payload && payload.answer.filter( ans =>{
                return ans.hasOwnProperty("TEST_QUESTION_ANSWER_TEXT"); 
            } ).length > 0 ){
                Vue.set( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload.questionId, payload.answer );
            }else{
                // remove the key if no answer provided
                Vue.delete( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload.questionId );
            }
        }else if( !payload || !payload.answer.length ){
            Vue.delete( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload.questionId );
        }else{
            Vue.set( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload.questionId, payload.answer ); 
        }
    },
    // updates the original answer choice with version with correct answer flg, test graded status etc set
    setGradedAnswer ( state, payload ){
        payload.forEach( ans => {
            let matchId = state.testPreview.ANSWERS.map( a =>{
                return a.ANSWER_RID; 
            } ).indexOf( ans.ANSWER_RID );
            state.testPreview.ANSWERS.splice( matchId, 1, ans );
        } );
    },
    updateStudentAnswers ( state, payload ){
        if( payload && !!payload[ 0 ].TEST_QUESTION_PARENT_RID ){
            Vue.set( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload[ 0 ].TEST_QUESTION_PARENT_RID, payload ); 
        }else{
            Vue.set( state.testPreview.STUDENT_ATTEMPT.ANSWERS, payload[ 0 ].TEST_QUESTION_RID, payload ); 
        }
    },
    // will increment correct answer total points
    setTotalPoints ( state, payload ){
        state.totalPointsEarned = payload;
    },
    // set the question currently being viewed
    setActiveQuestion ( state, payload ){
        let questionObj = state.testPreview.QUESTIONS.filter( q =>{
            return q.TEST_QUESTION_RID === payload; 
        } );
        state.activeQuestion = questionObj[ 0 ];
        
    },
    // flags and unflags questions
    toggleQuestionFlag ( state ){
        // get the id of the active question
        let activeId = state.activeQuestion.TEST_QUESTION_RID;
        let existingIndex = state.flaggedQuestions.indexOf( activeId );
        // if question is flagged, un-flag it, else set flag
        if(  existingIndex > -1 ){
            state.flaggedQuestions.splice( existingIndex, 1 );
        }else{
            state.flaggedQuestions.push( activeId );
        }
        /* update database with flagged questions */
        let payload = {
            queryParams:{},
            routeParams:{},
            data:{}
        };
        payload.routeParams.action = "flag-question";
        payload.routeParams.testRid = state.testPreview.TEST.TEST_RID;
        payload.queryParams.test_rid = state.testPreview.TEST.TEST_RID;
        payload.queryParams.school_id = state.testSession.school_id;
        payload.queryParams.course_id = state.testSession.course_id;
        payload.queryParams.section_id = state.testSession.section_id;
        payload.queryParams.teacher_rid = state.testSession.teacher_rid;
        payload.queryParams.student_rid = state.testSession.student_rid;
        payload.data.flaggedQuestions = state.flaggedQuestions;

        let TestTaker = new TestTakerResource({
            routeParams: payload.routeParams,
            query: payload.queryParams,
            data: payload.data
        });

        let promise = TestTaker.post();
            
    },
    

    
};

export default {
    state: initialState,
    actions,
    mutations,
    getters
};
